import { InjectionToken } from '@angular/core';
import { Config } from '../models/config.interface';

export const CONFIG = new InjectionToken<Config>('Config');
